export default __webpack_public_path__ + "static/media/co2.c4d487aa.png";